import * as Yup from 'yup';
import { COLLECTION_TYPES } from '../../pages/Collections/PageCollections/PageCollections.const';
import { targetValidationNullable } from '../../../../const/targetValidationNullable';
import { errorMessages } from '../../../../const/dateValidator';



export const makeValidationSchema = (collectionConfig, dynamicData = {}) => Yup.lazy((values) => Yup.object().shape({
  title: Yup.string()
    .nullable()
    .min(3, 'Min 3 symbols required')
    .max(2000, 'Max 2000 symbols required'),
  template_id: Yup.string().required('Required to specify template'),
  use_utc_zero_time: Yup.bool(),
  categories: Yup.array().min(1, 'Min 1 symbol required').of(Yup.number()),
  image_type: Yup.string().required('Required to specify image type').oneOf(collectionConfig?.image_types ?? []),
  type: Yup.string().required('Required to specify collection type').oneOf(COLLECTION_TYPES),
  released_at: Yup.date().nullable().before(values?.released_to, errorMessages.releasedAt.before),
  ...collectionConfig?.release_range && {
    released_to: Yup.date().nullable().after(values?.released_at, errorMessages.releasedTo.after),
  },
  target: Yup.object().shape(targetValidationNullable(values)),
  ...dynamicData,
}));
